import Vue from 'vue'

export const CURRENCY_PRESETS = {
  0: {
    code: 0, symbol: '€', locale: 'en-US', decimals: 2, position: 'suffix',
  },
  1: {
    code: 1, symbol: 'Rp', locale: 'id-ID', decimals: 0, position: 'suffix',
  },
  2: {
    code: 2, symbol: 'pts', locale: 'en-US', decimals: 0, position: 'suffix',
  },
  3: {
    code: 3, symbol: '$', locale: 'en-US', decimals: 2, position: 'prefix',
  },
}

const DEFAULT_CODE = (() => {
  const parsed = parseInt(process.env.VUE_APP_CURRENCY_DEFAULT, 10)
  return CURRENCY_PRESETS[parsed] ? parsed : 1
})()

const active = Vue.observable({ ...CURRENCY_PRESETS[DEFAULT_CODE] })

export function setActiveCurrency(code) {
  const preset = CURRENCY_PRESETS[code]
  if (!preset) return
  Object.assign(active, preset)
}

export function getCurrencySymbol() { return active.symbol }
export function getCurrencyCode() { return active.code }
export function getCurrencyPlaceholder() {
  return active.decimals > 0 ? (0).toFixed(active.decimals) : '0'
}

export function formatCurrency(value) {
  const n = Number.isFinite(Number(value)) ? Number(value) : 0
  const formatter = new Intl.NumberFormat(active.locale, {
    style: 'decimal',
    minimumFractionDigits: active.decimals,
    maximumFractionDigits: active.decimals,
  })
  const formatted = formatter.format(n)
  if (active.position === 'prefix') {
    return formatted.startsWith('-')
      ? `-${active.symbol}${formatted.slice(1)}`
      : `${active.symbol}${formatted}`
  }
  return `${formatted} ${active.symbol}`
}

export function ceilToCurrency(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return 0
  const factor = 10 ** active.decimals
  return Math.ceil(n * factor) / factor
}

export function floorToCurrency(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return 0
  const factor = 10 ** active.decimals
  return Math.floor(n * factor) / factor
}
